<template>
    <div class="container">

            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left">{{heading}}<span v-if="records.length>1"><small>(</small>s<small>)</small></span></h1>
            </div>
            <div class="shift-mangement-top-box mb-3">
              
            <table id="newshiftsrequest" class="table table-responsive-xl" style="width:100%">
                <thead>
                <tr>
                    <th>Name</th>
                    <th >Action</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="record in records">
                        <td>{{record.name}}</td>
                        <td>
                               <button class="btn btn-primary"  @click="deletedata(record.id)"><i class="fas fa-trash"></i></button>
                        </td>
                  </tr>
               </tbody>
            </table>
        </div>
</div>
</template>
<script>
    export default {
        data(){
            return{
              records:[],
              heading:'',
              flag:true,
              shiftName:''
            }
        },
        methods:{
           
            getList(){
                 this.$Progress.start();
                 let self=this;
                axios.get('/api/getUserDetail/'+this.$route.params['requestedBy']+'/'+this.$route.params['id']+'/'+this.$route.params['shiftId'])
                .then(res => {
                        self.records=res.data.data;
                        self.shiftName=res.data.shiftName;
                        self.$Progress.finish();
                        if(this.$route.params['requestedBy']=='individual'){
                            this.heading=self.shiftName+' Shift:Individual';                   
                            }else{
                            this.heading=self.shiftName+' Shift:'+this.$route.params['requestedBy']+':'+'User';
                            }
                        setTimeout(function(){ $('#newshiftsrequest').DataTable() }, 0);
                }).catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Something went wrong!');
                });
            },
             deletedata(id){
                 this.$Progress.start();
                 let self=this;
                axios.get('/api/deleteData/'+this.$route.params['requestedBy']+'/'+id+'/'+this.$route.params['shiftId']+'?flag='+this.flag)
                .then(res => {
                    // alert('ok');
                    self.showAlertBox('success','Employee deleted successfully!');
                    location.reload()
                }).catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Something went wrong!');
                });
            }
        },
        mounted(){
            let self=this;
            

              this.getList();
        }
    }
</script>